const messages = {
  en: {
    playAll: 'Play All',
    prev: 'Previous Step',
    next: 'Next Step',
    nextTutorial: 'Next Tutorial',
    previousTutorial: 'Previous Tutorial',
    flashError: 'Images for this tutorial are not supported on your browser.'
  },
  'es-ud': {
    playAll: 'Reproducir todos',
    prev: 'Paso previo',
    next: 'Próximo paso',
    nextTutorial: 'Siguiente tutorial',
    previousTutorial: 'Tutorial anterior',
    flashError:
      'Las imágenes de este tutorial no son compatibles con este dispositivo.'
  },
  es: {
    playAll: 'Reproducir todos',
    prev: 'Paso previo',
    next: 'Próximo paso',
    nextTutorial: 'Siguiente tutorial',
    previousTutorial: 'Tutorial anterior',
    flashError:
      'Las imágenes de este tutorial no son compatibles con este dispositivo.'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/Tutorial/messages.js